export default "__VITE_ASSET__A3UUEE0Q__"